import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=1bcd5463&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"
import style0 from "./Forms.vue?vue&type=style&index=0&id=1bcd5463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd5463",
  null
  
)

export default component.exports